import React from 'react';
import { observer } from 'mobx-react';

import { Section } from 'app/component/Section';
import { BirthCountryFormItem } from 'app/logic/pages/order/BirthCountryFormItem';
import { BelarusBirthLocalityFormItem } from 'app/logic/pages/order/BelarusBirthLocalityFormItem';
import { BirthLocalityTypeFormItem } from 'app/logic/pages/order/BirthLocalityTypeFormItem';
import { BirthLocalityFormItem } from 'app/logic/pages/order/BirthLocalityFormItem';
import { FieldSet } from 'app/component/fieldset/FieldSet';
import { OrderPageStore } from 'app/logic/pages/order/OrderPageStore';

export interface BirthPlaceFormSectionProps {
    pageStore: OrderPageStore;
}

export const BirthPlaceFormSection = observer(
    ({ pageStore }: BirthPlaceFormSectionProps) => {
        const { orderFormStore } = pageStore;

        return (
            <Section
                className={'birthPlaceFormSection'}
                title={'Место рождения'}
                content={
                    <FieldSet
                        className={'birthplaceFieldSet'}
                        fieldsProps={[
                            {
                                className: 'country',
                                title: '',
                                value: (
                                    <BirthCountryFormItem
                                        formStore={
                                            orderFormStore.birthPlaceFormStore
                                        }
                                    />
                                ),
                            },
                            {
                                className: 'locality',
                                title: '',
                                value: (
                                    <BelarusBirthLocalityFormItem
                                        formStore={
                                            orderFormStore.birthPlaceFormStore
                                        }
                                    />
                                ),
                                isVisible:
                                    orderFormStore.birthPlaceFormStore
                                        .isBelarusBirthCountry,
                            },
                            {
                                className: 'locality',
                                title: '',
                                value: (
                                    <>
                                        <BirthLocalityTypeFormItem
                                            formStore={
                                                orderFormStore.birthPlaceFormStore
                                            }
                                        />
                                        <BirthLocalityFormItem
                                            formStore={
                                                orderFormStore.birthPlaceFormStore
                                            }
                                        />
                                    </>
                                ),
                                isVisible:
                                    orderFormStore.birthPlaceFormStore
                                        .isForeignBirthCountry,
                            },
                        ]}
                    />
                }
            />
        );
    },
);
